export default __webpack_public_path__ + "static/media/placeholder.3c0a422b.jpg";